import PropTypes from 'prop-types';
import React from 'react';
import { Button, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import { Resource, resourceTypes } from '../../stores/ResourceStore';
import ResourceActions from '../../actions/ResourceActions';
import { capitalize, underscoresToSpaces } from '../../util/helpers/Strings';
import isValidJson from '../../util/isValidJson';
import { resourceNameDisplay } from './util';
import FAFormControlFeedback from '../../components/form_components/FAFormControlFeedback.react';

export const ResourceTypeSelect = ({ resource, onResourceTypeChange }) => (
  <div className='edit-secret-form-item'>
    <ControlLabel>Resource Type</ControlLabel>
    <FormControl
      componentClass='select'
      value={resource.resourceType || -1}
      onChange={onResourceTypeChange}
    >
      <option key={-1} value={-1}>
        Select Type...
      </option>
      {resourceTypes.map(resourceType => (
        <option key={resourceType} value={resourceType}>
          {underscoresToSpaces(capitalize(resourceType))}
        </option>
      ))}
    </FormControl>
  </div>
);

ResourceTypeSelect.propTypes = {
  resource: PropTypes.instanceOf(Resource),
  onResourceTypeChange: PropTypes.func,
};

export const ResourceNameInput = ({ resource, onUpdateResourceName }) => (
  <div className='edit-secret-form-item'>
    <ControlLabel>Resource Name</ControlLabel>
    <FormControl
      type='text'
      value={resource.resourceName || ''}
      className='secondary-input'
      onChange={onUpdateResourceName}
    />
  </div>
);

ResourceNameInput.propTypes = {
  resource: PropTypes.instanceOf(Resource),
  onUpdateResourceName: PropTypes.func,
};

export const ResourceInfoInput = ({ resource, onUpdateResourceInfo }) => (
  <div className='edit-secret-form-item'>
    <FormGroup validationState={isValidJson(resource.resourceInfo) ? 'success' : 'error'}>
      <ControlLabel>Resource Info</ControlLabel>
      <FormControl
        componentClass='textarea'
        rows={6}
        cols={40}
        value={(isValidJson(resource.resourceInfo) ?
          JSON.stringify(JSON.parse(resource.resourceInfo), null, 4)
          : resource.resourceInfo) || ''}
        className='secondary-input resource-info-input'
        onChange={onUpdateResourceInfo}
      />
      <FAFormControlFeedback />
    </FormGroup>
  </div>
);

ResourceInfoInput.propTypes = {
  resource: PropTypes.instanceOf(Resource),
  onUpdateResourceInfo: PropTypes.func,
};

export const EditResourceActionButtons = ({ resource, exitEditMode }) => {
  const onSave = () => {
    ResourceActions.saveResource(resource);
    exitEditMode();
  };

  const onDelete = () => {
    /* eslint-disable */
    if (confirm(`Are you sure you want to delete ${resourceNameDisplay(resource)}?`)) {
    /* eslint-enable */
      ResourceActions.deleteResource(resource.id);
    }
  };

  const exitEditModeAndRemoveUnsavedSecret = () => {
    if (resource.id === -1) {
      ResourceActions.removeUnsavedResource();
    }
    exitEditMode();
  };

  return (
    <div className='credential-buttons'>
      {
        resource.id !== -1 &&
          <div className='credential-button'>
            <Button
              bsStyle='danger'
              onClick={onDelete}
            >
              Delete
            </Button>
          </div>
      }
      <div className='credential-button'>
        <Button
          bsStyle='basic'
          onClick={exitEditModeAndRemoveUnsavedSecret}
        >
          Cancel
        </Button>
      </div>
      <div className='credential-button'>
        <Button
          bsStyle='primary'
          onClick={onSave}
          disabled={!resource.valid}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

EditResourceActionButtons.propTypes = {
  resource: PropTypes.instanceOf(Resource),
  exitEditMode: PropTypes.func,
};
